<template>
  <div class="content-source-filter-container">
    <v-select
      class="content-source-filter-control"
      :items="sources"
      item-text="display"
      v-model="selectedSources"
      :placeholder="controlLabel"
      outlined
      multiple
      return-object
    >
      <template slot="selection" slot-scope="{ item, index }">
        <span v-if="index === 0"> {{ selectedSources.length }} Sources </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashDebounce from "lodash/debounce";
import { mapGetters } from "vuex";
import { getSources } from "@/services/alerts/alerts.service.js";
import { MODULE_PREFIX_USER, MODULE_PREFIX_HOME } from "@/store";
import { SAVE_PREFERENCES } from "@/store/actions.type";
import { hasTwitterAccess } from "@/services/user/user.service";

export default {
  name: "ContentSourceFilter",
  props: {
    value: {
      type: Array,
    },
  },
  created() {
    this.getPrefs();
  },
  data() {
    return {
      sources: this.filteredSources(),
      selectedSources: [],
    };
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),

    controlLabel() {
      return this.selectedSources && this.selectedSources.length === 0
        ? "Sources"
        : "";
    },
  },
  methods: {
    filteredSources() {
      let sources = [];
      const SOURCES = getSources();
      SOURCES.map(function (item) {
        if (item.display !== null) {
          sources.push(item);
        }
      });
      return sources;
    },

    async savePrefs() {
      if (this.preferences.alerts && this.preferences.alerts.content) {
        this.preferences.alerts.content.sourceFilter = this.selectedSources;
        await this.$store.dispatch(
          MODULE_PREFIX_USER + SAVE_PREFERENCES,
          this.preferences
        );
      }
    },
    getPrefs() {
      const sourceFilter = lodashGet(
        this.preferences,
        "alerts.content.sourceFilter"
      );

      if (sourceFilter) {
        let filtersArr = lodashCloneDeep(
          this.preferences.alerts.content.sourceFilter
        );
        let newFiltersArr = [];

        filtersArr.forEach((item) => {
          if (item.id === "twitter") {
            if (hasTwitterAccess()) {
              newFiltersArr.push(item);
            }
          } else {
            newFiltersArr.push(item);
          }
        });

        this.selectedSources = newFiltersArr;
      } else {
        this.selectedSources = [];
      }

      // selectedData may contain a specific alertid
      if (lodashGet(this.selectorPanel, "selectedData")) {
        this.selectedSources = [];
      }
    },
  },
  watch: {
    selectedSources: lodashDebounce(function () {
      this.savePrefs();
    }, 500),
  },
};
</script>
<style scoped>
.content-source-filter-container {
  width: 125px;
  padding: 5px 5px 0 0;
}

.content-source-filter-control >>> .v-input__slot {
  border-radius: 10px;
  min-height: auto;
}

.content-source-filter-control >>> .v-label {
  top: auto;
  color: #646464;
}

.content-source-filter-control >>> .v-input__append-inner {
  display: none;
}

.content-source-filter-control >>> .v-select__selections {
  padding: 0 !important;
}
.content-source-filter-control >>> .v-select__selection {
  color: #646464;
}
</style>
